var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rich-marker',{attrs:{"marker":_vm.marker}},[_c('div',{staticClass:"user-position-pin"},[_c('div',{staticClass:"user-position-pin-icon bounce"}),_vm._v(" "),_c('div',{staticClass:"user-position-pin-pulse"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }